import React, { useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import {
  Accordion,
  AccordionDetails,
  Grid,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  Button,
} from "@mui/material";
import styles from "../../JobBatch.module.css";
import PdfIcon from "../../../../../shared/assets/icons/PdfIcon.png";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ModalToOpenEditJobs from "../../ModalToOpenEditJobs";
import RecceReport from "../../../../RFPDashboard/RecceApproval/RecceReport";

const AvailableJobs = ({
  availableJobs,
  selectedJobs,
  selectAll,
  setSelectAll,
  setSelectedJobs,
  updateJobInParent,
  allJobsBasedLoading,
  campaignData, // Make sure this prop is passed from parent
}) => {
  const [searchTermProduct, setSearchTermProduct] = useState("");
  const [searchTermCity, setSearchTermCity] = useState("");
  const [searchTermState, setSearchTermState] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openRecceReport, setOpenRecceReport] = useState(false);
  const [currentRecceJob, setCurrentRecceJob] = useState(null);
  const { id } = useParams();

  // Check if Recce service is needed in this campaign
  const isRecceNeeded =
    campaignData?.scopeOfWork?.servicesNeeded?.includes("Recce");

  const handleSelectJob = (job) => {
    setSelectedJobs((prevSelected) => {
      const isAlreadySelected = prevSelected.find(
        (item) => item._id === job._id,
      );
      return isAlreadySelected
        ? prevSelected.filter((item) => item._id !== job._id)
        : [...prevSelected, job];
    });
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedJobs(filteredJobs);
      setSelectAll(true);
    } else {
      setSelectedJobs([]);
      setSelectAll(false);
    }
  };

  const handleMenuClick = (event, job) => {
    setAnchorEl(event.currentTarget);
    setSelectedJob(job);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleEditJob = () => {
    setOpenModal(true);
    handleCloseMenu();
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // Function to handle opening the recce report
  const handleOpenRecceReport = (job) => {
    setCurrentRecceJob(job);
    setOpenRecceReport(true);
  };

  // Function to handle closing the recce report
  const handleCloseRecceReport = () => {
    setOpenRecceReport(false);
  };

  const updateJob = async (job) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/jobs/updateJob/${job._id}`,
        job,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating job:", error);
      return null;
    }
  };

  const handleSaveJob = async (updatedFields) => {
    if (!selectedJob || !selectedJob._id) {
      console.error("Selected job does not have an id");
      return;
    }

    const updatedJob = await updateJob(updatedFields);
    if (updatedJob) {
      updateJobInParent(updatedJob);
      handleCloseModal();
    }
  };

  const filteredJobs = availableJobs.filter((job) => {
    const matchesProduct = searchTermProduct.trim()
      ? job?.productId?.productType
          ?.toLowerCase()
          .includes(searchTermProduct.toLowerCase())
      : true;
    const matchesCity = searchTermCity.trim()
      ? job.city?.toLowerCase().includes(searchTermCity.toLowerCase())
      : true;
    const matchesState = searchTermState.trim()
      ? job.state?.toLowerCase().includes(searchTermState.toLowerCase())
      : true;
    return matchesProduct && matchesCity && matchesState;
  });

  return (
    <Grid className={`${styles.scrollableContainer}`}>
      <Grid item xs={12} md={12} my={1} mx={2}>
        <div className="flex justify-start items-center my-2 flex-wrap gap-2">
          <input
            type="text"
            placeholder="Search product"
            value={searchTermProduct}
            onChange={(e) => setSearchTermProduct(e.target.value)}
            className={`${styles.searchInput}`}
          />
          <input
            type="text"
            placeholder="Search city"
            value={searchTermCity}
            onChange={(e) => setSearchTermCity(e.target.value)}
            className={`${styles.searchInput}`}
          />
          <input
            type="text"
            placeholder="Search state"
            value={searchTermState}
            onChange={(e) => setSearchTermState(e.target.value)}
            className={`${styles.searchInput}`}
          />
          {filteredJobs.length > 0 && (
            <Box ml={1}>
              <strong>{filteredJobs.length}</strong> job
              {filteredJobs.length > 1 ? "s" : ""} found
            </Box>
          )}
        </div>

        {!allJobsBasedLoading ? (
          filteredJobs.length === 0 ? (
            <div className={styles.noJobsStyle}>
              <Box className={styles.noJobsBox}>
                <p className={styles.noJobsText}>No jobs available</p>
              </Box>
            </div>
          ) : (
            <Accordion>
              <AccordionDetails className={styles.accordionDetails}>
                {/* Render Job Details Table */}
                <Box className={`${styles.scrollableBox}`}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow className={styles.tableHeader}>
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={selectAll}
                              onChange={handleSelectAll}
                            />
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            CITY
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            ADDRESS
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            STORE MANAGER
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            DRIVER DETAILS
                          </TableCell>
                          <TableCell className={styles.tableCell}>
                            PRODUCT TYPE
                          </TableCell>
                          {/* <TableCell className={styles.tableCell}>
                          JOB DATE
                        </TableCell> */}
                          {/* <TableCell className={styles.tableCell}>
                          JOB PAY
                        </TableCell> */}
                          {/* <TableCell className={styles.tableCell}>
                          ALLOTED TIME
                        </TableCell> */}
                          {/* <TableCell className={styles.tableCell}>
                          LOT NO
                        </TableCell> */}
                          {/* Conditionally render RECCE REPORT column */}
                          {isRecceNeeded && (
                            <TableCell className={styles.tableCell}>
                              RECCE REPORT
                            </TableCell>
                          )}
                          <TableCell className={styles.tableCell}>
                            ACTION
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {filteredJobs.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={selectedJobs?.some(
                                  (item) => item._id === row._id,
                                )}
                                onChange={() => handleSelectJob(row)}
                              />
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.city}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row?.storeName || "NA"}
                              </div>
                              <div className={styles.address2}>
                                {row?.address || "NA"}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.storeOwnerName}
                              </div>
                              <div className={styles.storeManagerContact}>
                                {row.storeOwnerPhoneNumber}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row.driverDetails?.driverName || "NA"}
                              </div>
                              <div className={styles.address2}>
                                {row.driverDetails?.driverPhoneNumber || "NA"} |{" "}
                                {row.driverDetails?.vehicleNumber || "NA"}
                              </div>
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <div className={styles.sharedTextStyle}>
                                {row?.productId?.productType}
                              </div>
                            </TableCell>
                            {/* <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.jobStartingDate ? row.jobStartingDate : "N/A"}
                            </div>
                          </TableCell> */}
                            {/* <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              ₹{row.paymentAmount ? row.paymentAmount : "N/A"}
                            </div>
                          </TableCell> */}

                            {/* <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.AllotedTime}
                            </div>
                          </TableCell> */}
                            {/* <TableCell className={styles.tableCell}>
                            <div className={styles.sharedTextStyle}>
                              {row.LotNo}
                            </div>
                          </TableCell> */}
                            {/* Conditionally render recce report cell */}
                            {isRecceNeeded && (
                              <TableCell className={styles.tableCell}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => handleOpenRecceReport(row)}
                                >
                                  <img
                                    src={PdfIcon}
                                    alt="PDF Icon"
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      marginRight: "8px",
                                    }}
                                  />
                                  <a
                                    href="#"
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "none",
                                      color: "inherit",
                                    }}
                                  >
                                    {row.RecceReport}
                                  </a>
                                </div>
                              </TableCell>
                            )}
                            {/* <TableCell>
                            <button className={styles.editButton}>Edit</button>
                          </TableCell> */}
                            <TableCell className={styles.tableCell}>
                              {row.status != 2 && (
                                <IconButton
                                  onClick={(event) =>
                                    handleMenuClick(event, row)
                                  }
                                >
                                  <MoreVertIcon />
                                </IconButton>
                              )}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </AccordionDetails>
            </Accordion>
          )
        ) : (
          <div className={styles.noJobsStyle}>
            <CircularProgress />
          </div>
        )}

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem onClick={handleEditJob}>Edit Job</MenuItem>
        </Menu>
        <ModalToOpenEditJobs
          open={openModal}
          handleClose={handleCloseModal}
          selectedJob={selectedJob}
          setSelectedJob={setSelectedJob}
          handleSaveJob={handleSaveJob}
          showJobPayField={false}
        />

        {/* Recce Report Dialog */}
        <Dialog
          open={openRecceReport}
          onClose={handleCloseRecceReport}
          maxWidth="lg"
          fullWidth
          className="custom-dialog"
          PaperProps={{
            className: "custom-dialog-paper",
          }}
        >
          <DialogContent>
            {currentRecceJob && (
              <RecceReport
                setOpen={setOpenRecceReport}
                open={openRecceReport}
                currentApproval={currentRecceJob}
                finalSpaces={[]}
              />
            )}
          </DialogContent>
        </Dialog>
      </Grid>
    </Grid>
  );
};

export default AvailableJobs;
